// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"ServicesContainer_Wrapper__1f8gR","ServicesWrapper":"ServicesContainer_ServicesWrapper__2LWOP","ServicesContainer":"ServicesContainer_ServicesContainer__3F4Zv"};